import { makeStyles } from "tss-react/mui"
import { TextField } from "@mui/material"
import React from "react"
import { useDebouncedInput } from "../../../../../shared/hooks/useDebouncedInput"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { sanitizeSearchQuery } from "../../../../../lib/stringLib"

const useStyles = makeStyles()(() => ({
    textInput: {
        width: "15rem",
    },
}))

export function OrderIdInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const { classes } = useStyles()
    const { innerValue, setInnerValue } = useDebouncedInput(value, onChange)

    return (
        <LocalizedStrict id="support-printer-queue-order-id-label" attrs={{ label: true }}>
            <TextField
                className={classes.textInput}
                name="orderId"
                value={innerValue}
                label="Order ID"
                onChange={(e) => setInnerValue(sanitizeSearchQuery(e.target.value))}
            />
        </LocalizedStrict>
    )
}
